<ion-app>
  <ion-split-pane contentId="main-content" when="md">
    <ion-menu [swipeGesture]="false" contentId="main-content" type="overlay">
      <ion-header>
        <ion-toolbar>
          <ion-title>{{
            'domain.tabs.page.tabs.menuTitle' | transloco
          }}</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list id="menu-list" lines="none">
          <ion-item
            [routerLink]="['/home']"
            routerLinkActive="active-menu-item"
            [routerLinkActiveOptions]="{ exact: true }"
            button
          >
            <ion-icon name="home-outline" slot="start"></ion-icon>
            <ion-label>{{
              'domain.tabs.page.tabs.button.home' | transloco
            }}</ion-label>
          </ion-item>
          <ion-item
            [routerLink]="['/explore']"
            routerLinkActive="active-menu-item"
            button
          >
            <ion-icon name="search-outline" slot="start"></ion-icon>
            <ion-label>{{
              'domain.tabs.page.tabs.button.services' | transloco
            }}</ion-label>
          </ion-item>
          <ion-item
            [routerLink]="['/agenda']"
            routerLinkActive="active-menu-item"
            button
          >
            <ion-icon name="calendar-outline" slot="start"></ion-icon>
            @if (upcomingTodayCount$ | async) {
              <ion-badge color="danger" slot="end">
                {{ upcomingTodayCount$ | async }}
              </ion-badge>
            }
            <ion-label>{{
              'domain.tabs.page.tabs.button.agenda' | transloco
            }}</ion-label>
          </ion-item>
          <ion-item
            [routerLink]="['/menu']"
            routerLinkActive="active-menu-item"
            [routerLinkActiveOptions]="{ exact: false }"
            button
          >
            <ion-icon name="person-outline" slot="start"></ion-icon>
            <ion-label>{{
              'domain.tabs.page.tabs.button.account' | transloco
            }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <div id="main-content" class="main-content">
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
</ion-app>
